<template>
  <div class="flowsSerlectContractAndProject">
    <van-popup position="right" :close-on-click-overlay="false" round v-model="show" :style="{ width: '90%',backgroundColor:'#eae9e9'}">
      <van-nav-bar title="请双击选择合同或项目" left-text="取消"  @click-left="close" />
      <van-search :placeholder="searchPromptText" v-model="searchText" show-action @input="onSearch" clearable shape="round">
        <template v-if="tabType == 'project'" #action>
          <div @click="changeProjectMore">{{ projectMoreTest }}</div>
        </template>
      </van-search>
      <van-tabs @click="onClickTabs" type="card">
        <van-tab :title="projectTabTest" name="project">
          <div style="overflow-y: auto" class="h-vh-70">
            <div style="overflow-y: auto" class="h-vh-70">
            <div class="p-10">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished" finished-text="没有更多了" @load="getProjectList"
                          class="p-l-20 p-r-20 p-b-20">
                  <div @click="clickItem(item)" v-for="(item,index) in projectList" :key="index" class="bg-FF p-20 m-t-20 b-r-10" :style="{border: item.activated ? '3px solid #F8B91A' : ''}">
                    <div class="flex col-center row-between">
                      <!-- 标题 -->
                      <div class="flex-1 font-30 cor-3E3A39 font-weight-600">
                        {{ item.projectName }}
                      </div>
                    </div>
                    <van-row type="flex" align="center" class="m-t-10">
                      <van-col span="10">
                        <div class="cor-88 font-30">项目负责人</div>
                      </van-col>
                      <van-col span="14">
                        <div class="cor-33 font-30 van-multi-ellipsis--l3">
                          {{ item.projectManagerName }}
                        </div>
                      </van-col>
                    </van-row>
                    <van-row type="flex" align="center" class="m-t-10">
                      <van-col span="10">
                        <div class="cor-88 font-30">创建时间</div>
                      </van-col>
                      <van-col span="14">
                        <div class="cor-33 font-30 van-multi-ellipsis--l3">
                          {{ item.createTime }}
                        </div>
                      </van-col>
                    </van-row>

                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
          </div>
          </div>
        </van-tab>
        <van-tab title="合同" name="contract">
          <div style="overflow-y: auto" class="h-vh-70">
            <div class="p-10">
              <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
                <van-list :immediate-check="false" v-model="loading" :error.sync="error" :finished="finished" finished-text="没有更多了" @load="getContractList"
                          class="p-l-20 p-r-20 p-b-20">
                  <div @click="clickItem(item)" v-for="(item,index) in contractList" :key="index" class="bg-FF p-20 m-t-20 b-r-10" :style="{border: item.activated ? '3px solid #F8B91A' : ''}">
                    <div class="flex col-center row-between">
                      <!-- 标题 -->
                      <div class="flex-1 font-30 cor-3E3A39 font-weight-600">
                        {{ item.contractName }}
                      </div>
                    </div>
                    <van-row type="flex" align="center" class="m-t-10">
                      <van-col span="10">
                        <div class="cor-88 font-30">合同金额</div>
                      </van-col>
                      <van-col span="14">
                        <div class="cor-33 font-30 van-multi-ellipsis--l3">
                          {{ item.contractAmount }}
                        </div>
                      </van-col>
                    </van-row>
                    <van-row type="flex" align="center" class="m-t-10">
                      <van-col span="10">
                        <div class="cor-88 font-30">签订客户</div>
                      </van-col>
                      <van-col span="14">
                        <div class="cor-33 font-30 van-multi-ellipsis--l3">
                          {{ item.customerCompanyName }}
                        </div>
                      </van-col>
                    </van-row>

                  </div>
                </van-list>
              </van-pull-refresh>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </van-popup>
  </div>
</template>
<script>
import {contractListByUserId, projectListByUserId} from '@/api/flow'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    userId: {
      type: String,
      default: false
    }
  },
  watch: {
    tabType(nv) {
      if(nv=="project") {
        this.searchPromptText = '请输入项目名称'
      }else {
        this.searchPromptText = '请输入合同名称'
      }
    },
    projectMoreStatus(nv) {
      if(nv) {
        this.queryParams.more=true;
        this.projectMoreTest = '我的';
        this.projectTabTest = "全部项目"
      }else{
        this.queryParams.more=false;
        this.projectMoreTest = '全部';
        this.projectTabTest = "我的项目"
      }
      this.onSearch()
    }
  },
  data() {
    return {
      lastClickTime: 0,
      contractList: [],
      projectList: [],
      loading: false,
      finished: false,
      refreshing: false,
      error: false,
      selectedContract: {},
      selectedProject: {},
      selectdList: [],
      queryParams: {
        pageNum: 1,
        pageSize: 20,
        contractName: '',
        projectName: '',
      },
      tabType: 'project',
      // 搜索框提示词
      searchPromptText: '请输入项目名称',
      searchText:'',
      // 项目更多
      projectMoreTest: "全部",
      projectTabTest: "我的项目",
      projectMoreStatus: false,
    }
  },
  created() {
    // this.init()
  },
  methods: {
    changeProjectMore() {
      this.projectMoreStatus = !this.projectMoreStatus;
    },
    init() {
      this.onRefresh();
    },
    onClickTabs(name, title) {
      this.tabType = name;
      this.onRefresh();
    },
    close() {
      this.$emit('close')
      this.contractList.forEach(item => {
        delete item.activated
      })
    },
    clickItem(item) {
      const currentTime = new Date().getTime();
      const clickInterval = currentTime - this.lastClickTime;
      if (clickInterval < 300) {
        // 双击事件
        this.clickCount++;
      } else {
        this.clickCount = 1;
      }
      this.lastClickTime = currentTime;

      if (this.clickCount === 2) {
        // 执行双击操作
        this.selectItem(item)
        this.clickCount = 0;
      }else {
        this.changeContent(item);
      }
    },
    // 选择合同
    changeContent(item) {
      this.contractList.forEach(ele => {
          this.$set(ele, 'activated', false)
      })
      this.projectList.forEach(ele => {
          this.$set(ele, 'activated', false)
      })
      this.$set(item, 'activated', true)
      this.selectedContract = item;
    },
    // 下拉
    onRefresh() {
      this.finished = false;
      this.contractList = []
      this.projectList = []
      this.queryParams.pageNum = 1
      if(this.tabType=='project') {
        this.getProjectList();
      }else if (this.tabType=='contract') {
        this.getContractList();
      }
      
    },
    selectItem(item) {
      item.selectType = this.tabType
      this.$emit('finish', item)
    },
    onSearch(text) {
      // this.queryParams.title = text;
      // this.finished = false
      // this.queryParams.pageNum = 1;
      // this.contractList = []
      // this.projectList = []
      // this.getContractList();
      this.onRefresh();
    },
    getContractList() {
      this.loading = true;
      this.queryParams.projectName='';
      this.queryParams.userId = this.userId;
      this.queryParams.contractName = this.searchText;
      contractListByUserId(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        if(res.total === this.contractList.length){
          this.finished = true
          this.loading = false;
          this.refreshing = false;
          return
        }
        this.contractList = this.contractList.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        this.error = true
      })
    },
    getProjectList() {
      this.loading = true;
      this.queryParams.contractName='';
      this.queryParams.projectMember = this.userId;
      this.queryParams.projectName = this.searchText;
      projectListByUserId(this.queryParams).then(res => {
        if (res.rows.length === 0) {
          this.finished = true
        }
        if(res.total === this.projectList.length){
          this.finished = true
          this.loading = false;
          this.refreshing = false;
          return
        }
        this.projectList = this.projectList.concat(res.rows)
        this.queryParams.pageNum++
        this.loading = false;
        this.refreshing = false;
      }).catch(err => {
        this.error = true
      })
    }

  }
}
</script>
<style lang="less">
.activated {
  border: 1px solid @theme-color;
}
.flowsSerlectContractAndProject {
      .van-tabs__nav--card {
        box-sizing: border-box;
        height: 0.8rem;
        margin: 0 0;
        border: 0.02667rem solid #FFDA3E;
        border-radius: 0.05333rem;
    }
  }

</style>

